import * as React from 'react';
export const claudeSvg = React.forwardRef(function claudeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#d97757',
      d: 'm8.709 19.956 4.72-2.648.08-.23-.08-.128h-.23l-.79-.048-2.698-.073-2.339-.097-2.266-.122-.571-.121L4 15.784l.055-.352.48-.321.686.06 1.52.104 2.278.157 1.652.098 2.449.255h.389l.054-.158-.133-.098-.104-.097-2.357-1.596-2.552-1.688-1.337-.972-.723-.491-.364-.462-.158-1.008.656-.722.881.06.225.061.893.686 1.908 1.476 2.491 1.833.365.304.145-.103.019-.073-.164-.274-1.355-2.446-1.446-2.49-.644-1.032-.17-.619a3 3 0 0 1-.104-.729l.748-1.013.413-.134.996.134.42.364.62 1.414 1.002 2.229 1.555 3.03.456.898.243.832.09.255h.159v-.146l.128-1.706.237-2.095.23-2.695.08-.76.376-.91.747-.492.584.28.48.685-.067.444-.286 1.851-.559 2.903-.364 1.942h.212l.243-.242.985-1.306 1.652-2.064.73-.82.85-.904.547-.431h1.033l.76 1.129-.34 1.166-1.064 1.347-.881 1.142-1.264 1.7-.79 1.36.073.11.188-.02 2.856-.606 1.543-.28 1.841-.315.833.388.09.395-.327.808-1.969.485-2.309.462-3.439.813-.042.03.048.061 1.55.146.662.036h1.622l3.02.225.79.522.474.638-.08.485-1.214.62-1.64-.389-3.829-.91-1.312-.328h-.182v.109l1.093 1.068 2.005 1.81 2.51 2.331.127.577-.322.455-.34-.048-2.205-1.658-.851-.747-1.926-1.62h-.128v.17l.444.649 2.345 3.521.122 1.081-.17.352-.608.213-.668-.122-1.374-1.924-1.415-2.168-1.143-1.943-.14.08-.674 7.254-.316.37-.729.28-.607-.461-.322-.747.322-1.475.389-1.925.315-1.53.286-1.9.17-.632-.012-.042-.14.018-1.434 1.967-2.181 2.945-1.726 1.845-.413.164-.717-.37.067-.662.401-.589 2.388-3.035 1.44-1.883.93-1.086-.006-.158h-.055L8.132 22.56l-1.13.146-.487-.455.061-.747.231-.243 1.908-1.311z',
    }),
  );
});
claudeSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var claude = {
  category: 'brand',
  colorable: false,
  name: 'claude',
  svg: claudeSvg,
};
